const addZero = (value) => (value < 10 ? `0${value}` : value);
var createTime = (value, type) => {
    const date = new Date(value);
    let result = '';
    switch (type) {
        case 'hour': {
            const hour = addZero(date.getHours());
            const minutes = addZero(date.getMinutes());
            result = `${hour}:${minutes}`;
            break;
        }
    }
    return result;
};

export { createTime as default };
